import { render, staticRenderFns } from "./hdCollectPrint.vue?vue&type=template&id=152dbf49&scoped=true"
import script from "./hdCollectPrint.vue?vue&type=script&lang=js"
export * from "./hdCollectPrint.vue?vue&type=script&lang=js"
import style0 from "./hdCollectPrint.vue?vue&type=style&index=0&id=152dbf49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152dbf49",
  null
  
)

export default component.exports